import { render } from "./WasteForm.vue?vue&type=template&id=d2c94470"
import script from "./WasteForm.vue?vue&type=script&lang=js"
export * from "./WasteForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__